/** @format */

import Name from "../../../assets/images/Name.svg";
import Gold from "../../../assets/images/Gold Bars.svg";
import Hashtag from "../../../assets/images/Hashtag Large.svg";
import Palette from "../../../assets/images/Paint Palette.svg";
import Letter from "../../../assets/images/Letter.svg";
import Info from "../../../assets/images/More Info.svg";
import { useEffect, useState } from "react";
import { ProfileModal } from "../profilemodal";
import { SocialModal } from "../socialmodal";
import { CardComponent } from "../cardcomponent";
import { ContactModal } from "../contactmodal";
import { HeroModal } from "../heromodal";
import AboutModal from "../aboutmodal";
import { Container, InfoContact, ContactUs } from "./styles";
import { PaymentModal } from "../../profile/paymentmodal";
import axios from "axios";
import { API_URL } from "../../../constants";
import { useSelector } from "react-redux";

interface HomeTabProps {
  isHomeActive: boolean;
  refreshProfile: boolean;
  setRefreshProfile: any;
  profile: any;
}
const HomeTab = ({ isHomeActive, refreshProfile, setRefreshProfile, profile }: HomeTabProps) => {
  const [edit, setEdit] = useState({
    isProfileActive: false,
    isPaymentActive: false,
    isSocialActive: false,
    isContactActive: false,
    isHeroActive: false,
    isAboutActive: false,
  });
  const [socials, setSocials] = useState<any>();
  const [hero, setHero] = useState<any>();
  const [account, setAccount] = useState<any>();
  const [contact, setcontact] = useState<any>();
  const [refresh, setRefresh] = useState(false);

  let businessUuid = useSelector((state: any) => state.auth.uuid);

  const toggleClear = () => {
    setEdit({
      isProfileActive: false,
      isPaymentActive: false,
      isSocialActive: false,
      isContactActive: false,
      isHeroActive: false,
      isAboutActive: false,
    });
  };

  const toggleProfile = () => {
    setEdit({
      isProfileActive: true,
      isPaymentActive: false,
      isSocialActive: false,
      isContactActive: false,
      isHeroActive: false,
      isAboutActive: false,
    });
  };
  const togglePayment = () => {
    setEdit({
      isProfileActive: false,
      isPaymentActive: true,
      isSocialActive: false,
      isContactActive: false,
      isHeroActive: false,
      isAboutActive: false,
    });
  };
  const toggleSocial = () => {
    setEdit({
      isProfileActive: false,
      isPaymentActive: false,
      isSocialActive: true,
      isContactActive: false,
      isHeroActive: false,
      isAboutActive: false,
    });
  };
  const toggleContact = () => {
    setEdit({
      isProfileActive: false,
      isPaymentActive: false,
      isSocialActive: false,
      isContactActive: true,
      isHeroActive: false,
      isAboutActive: false,
    });
  };
  const toggleHero = () => {
    setEdit({
      isProfileActive: false,
      isPaymentActive: false,
      isSocialActive: false,
      isContactActive: false,
      isHeroActive: true,
      isAboutActive: false,
    });
  };
  const toggleAbout = () => {
    setEdit({
      isProfileActive: false,
      isPaymentActive: false,
      isSocialActive: false,
      isContactActive: false,
      isHeroActive: false,
      isAboutActive: true,
    });
  };

  const getSocial = async () => {
    axios
      .get(`${API_URL}/socials/${businessUuid}`)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setSocials(response.data.data.socials);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 400 || error?.response?.status === 401) {
          return;
        }
      });
  };
  const getHero = async () => {
    axios
      .get(`${API_URL}/heroandheader/${businessUuid}`)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setHero(response.data.data);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 400 || error?.response?.status === 401) {
          return;
        }
      });
  };
  const getContact = async () => {
    axios
      .get(`${API_URL}/contact/${businessUuid}`)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setcontact(response.data.data.contact);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 400 || error?.response?.status === 401) {
          return;
        }
      });
  };
  const getAccount = async () => {
    axios
      .get(`${API_URL}/bank_account_details/${businessUuid}`)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setAccount(response.data.data.accountDetails);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 400 || error?.response?.status === 401) {
          return;
        }
      });
  };

  useEffect(
    () => {
      setRefreshProfile(!refreshProfile);
      getSocial();
      getHero();
      getContact();
      getAccount();
    },
    // eslint-disable-next-line
    [refresh]
  );

  const cardDetails = [
    {
      status: profile?.isBasicInfoSet === false ? "Not Done" : profile?.isBasicInfoSet === true ? "Done" :'',
      icon: Name,
      Descrip: "Click to Setup Basic Information",
      toggle: toggleProfile,
    },
    {
      status: account?.isSet === false ? "Not Done" : account?.isSet === true ? "Done" :'',
      icon: Gold,
      Descrip: "Click to Setup Payout Information",
      toggle: togglePayment,
    },
    {
      status: socials?.isSet === false ? "Not Done" : socials?.isSet === true ? "Done" :'',
      icon: Hashtag,
      Descrip: "Click to Setup Social Information",
      toggle: toggleSocial,
    },
    {
      status: contact?.isSet === false ? "Not Done" : contact?.isSet === true ? "Done" :'',
      icon: Letter,
      Descrip: "Click to Setup Contact Information",
      toggle: toggleContact,
    },
    {
      status:hero?.isSet === false ? "Not Done" : hero?.isSet === true ? "Done" :'',
      icon: Palette,
      Descrip: "Click to Setup Hero Section and Header",
      toggle: toggleHero,
    },
    {
      status: profile?.isAboutSet === false ? "Not Done" : profile?.isAboutSet === true ? "Done" : "",
      icon: Info,
      Descrip: "Click to Setup About Section",
      toggle: toggleAbout,
    },
  ];
  return (
    <div hidden={!isHomeActive}>
      <Container hidden={!isHomeActive}>
        {cardDetails.map((card, id) => (
          <CardComponent key={id} status={card.status} icon={card.icon} toggle={card.toggle} descrip={card.Descrip} />
        ))}
      </Container>
      <InfoContact>
        Need help?{" "}
        <ContactUs>
          {" "}
          <a href="https://wa.me/message/MDP76I5CDKCGG1" target="_blank" rel="noopener noreferrer">
            Contact Us
          </a>
        </ContactUs>{" "}
      </InfoContact>
      {edit.isProfileActive ? (
        <ProfileModal toggleClear={toggleClear} profile={profile} setRefresh={setRefresh} refresh={refresh} />
      ) : null}
      {edit.isPaymentActive ? (
        <PaymentModal toggleClear={toggleClear} account={account} setRefresh={setRefresh} refresh={refresh} />
      ) : null}
      {edit.isSocialActive ? (
        <SocialModal toggleClear={toggleClear} socials={socials} setRefresh={setRefresh} refresh={refresh} />
      ) : null}
      {edit.isContactActive ? (
        <ContactModal toggleClear={toggleClear} contact={contact} setRefresh={setRefresh} refresh={refresh} />
      ) : null}
      {edit.isHeroActive ? (
        <HeroModal toggleClear={toggleClear} setRefresh={setRefresh} refresh={refresh} hero={hero} />
      ) : null}
      {edit.isAboutActive ? (
        <AboutModal toggleClear={toggleClear} profile={profile} setRefresh={setRefresh} refresh={refresh} />
      ) : null}
    </div>
  );
};

export default HomeTab;
